module.exports = __webpack_public_path__ + "static/media/success(13).d6228904.png";